/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Grid_LabelInputs */

const vi_media_grid_label = /** @type {(inputs: Media_Grid_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách ảnh và video`)
};

/**

* @param {Media_Grid_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_grid_label = /** @type {((inputs?: Media_Grid_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Grid_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_grid_label(inputs)
});